// Import Packages
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';

// Import Pages
import { timeZones } from "../../automs/autom/leftSideBar/variables/timeZones/TimeZones";

// Import Material UI
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Dialog, DialogTitle } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

// Import Services
import MateService from '../../../../services/MateService/MateService';

// Import Recoil
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';

// Import Icons
import CloseIcon from '../../../../assets/icons/close-icon.svg';

// Import CSS
// import './MateDetail.css'

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    option: {
        '& > span': {
            marginRight: 10,
            fontSize: 12,
        },
        fontSize: 13,
        fontWeight: 600,
        color: '#46474E',
    },
    inputRoot: {
        "& fieldset": {
            borderColor: '#E6E6E6',
            borderWidth: '1.1px'
        }
    },
    popupIndicator: {
        color: "#B0B0B0",
        height: "10px",
        width: "10px"
    }
}));

function TimeZone({ mate_id, zone, save, cancel, setOpenConfirm, setSelectedMateId, buttonRef  }) {
    const { t } = useTranslation();
    const [selectedTimeZone, setSelectedTimeZone] = useState({});
    const [openConfirmation, setOpenConfirmation] = useState(false);

    const classes = useStyles();

    const setAlert = useSetRecoilState(alertState);

    const label = "CONTENT.MYMATES."

    useEffect(() => {
        if (zone) {
            let z = timeZones.find(x => x.value === zone);
            setSelectedTimeZone(z ? z : {});
        } else {
            setSelectedTimeZone({})
        }
    }, []);

    const submit = async () => {
        const response = await MateService.updateTimeZone(mate_id, selectedTimeZone.value);
        if (response.code === 200) {
            setAlert(alert => ({ ...alert, show: true, message: t(label + 'SUCCESSFULLY-UPDATED'), severity: 'success' }))
            save(selectedTimeZone.value);
        } else {
            if (response.hasOwnProperty("rsa")) {
                setOpenConfirm(true);
                setSelectedMateId(mate_id);
            }
            setAlert(alert => ({ ...alert, show: true, message: t(label + response.message), severity: 'error' }))
        }
    }

    return (
        <Dialog open={true} className='mate-detail-modal'>
            <div className='min-w-350'>
                <DialogTitle id="alert-dialog-title">
                    <div id="about-title" className="add-group-header">
                        <h4 className="autom-group-title">{t("CONTENT.AUTOMS-LIST.TIME-ZONE")}</h4>
                        <div className='items-center-end'>
                            <img className='transform-cancel-icon' src={CloseIcon} onClick={() => cancel()} />
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <Autocomplete
                        value={selectedTimeZone}
                        onChange={(e, newValue) => setSelectedTimeZone(newValue ? newValue : {})}
                        id={`variable-time-zone`}
                        style={{ position: 'relative', background: '#FBFBFB', marginBottom: '15px' }}
                        size="small"
                        options={timeZones}
                        classes={{
                            option: classes.option,
                            inputRoot: classes.inputRoot,
                            popupIndicator: classes.popupIndicator
                        }}
                        autoHighlight
                        getOptionLabel={(option) => option.value ? `${option.value} ${option.dst ? `(Standard: ${option.utc}, DST: ${option.dst})` : `(${option.utc})`}` : ""}
                        renderOption={(option) => (
                            <>
                                {`${option.value} ${option.dst ? `(Standard: ${option.utc}, DST: ${option.dst})` : `(${option.utc})`}`}
                            </>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                id='select-time-zone-text'
                                className="select-action-input"
                                placeholder={t("CONTENT.AUTOMS-LIST.SELECT-TIME-ZONE")}
                                variant="outlined"
                                classes={{
                                    root: classes.inputRoot
                                }}
                                inputProps={{
                                    ...params.inputProps,
                                    "aria-autocomplete": 'new-password',
                                    autoComplete: 'new-password', // disable autocomplete and autofill
                                    style: {
                                        marginLeft: '5px',
                                        fontSize: 12,
                                        fontWeight: 600,
                                        color: '#46474E'
                                    }
                                }}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions
                    style={{
                        justifyContent: "center",
                        padding: "8px 24px 16px 24px",
                    }}
                >
                    <div className={classes.bottomSection}>
                        <button
                            ref={buttonRef}
                            type="button"
                            onClick={submit}
                            data-test="createautom-button"
                            className={`button-save`}
                            style={{
                                width: "128px",
                                height: "27px",
                                borderRadius: "4px",
                                boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)"
                            }}
                        >
                            {t("CONTENT.AUTOMS-LIST.SAVE")}
                        </button>
                    </div>
                </DialogActions>
            </div>

        </Dialog>
    )
}

export default TimeZone;
